import ContentSearchResults from './ContentSearchResults';

export * from './ContentSearchResults';
export default ContentSearchResults;
